import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import Scene = Phaser.Scene;
import {Artifact} from "@/store/artifact/types";
import {ArtifactSlot, UnlockState} from "@/scenes.ui/artifact-slot";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import CU from "@/utils/c-u";

export class ArtifactNavPanel extends AbstractNavPanel {

    private onPanelPressCallback!: (artifact: Artifact) => unknown;
    private crNameByArtId!: Map<number, string>;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, artifacts: Artifact[], crNameByArtId: Map<number, string>,
                onPanelPressCallback: (artifact: Artifact) => unknown) {
        super(scene, canvas, x, y, artifacts, 3, (ths: ArtifactNavPanel) => {
            ths.crNameByArtId = crNameByArtId;
        });
        this.setScale(CU.S, CU.S)

        this.onPanelPressCallback = onPanelPressCallback;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 120 / CU.S;
    }

    protected getButtonX(): number {
        return 195 / CU.S;
    }

    protected getButtonY(): number {
        return 150 / CU.S;
    }

    protected makePanel(x: number, element: any): any {

        let artifact: Artifact = <Artifact>element;

        return new SlotAndName(this.scene!, x * CU.S, 150, 110, artifact, this.crNameByArtId.get(artifact.id)!, () => {
            this.playSelectSound();
            if (this.onPanelPressCallback != null) {
                this.onPanelPressCallback(artifact);
            }

        });
    }
}

export class SlotAndName extends ArtifactSlot {

    constructor(scene: Scene, x: number, y: number, size: number, art: Artifact, creatureName: string, clickCallback: () => unknown) {
        super(scene, x, y, size, art, false, UnlockState.UNLOCKED, clickCallback);

        let nameLabel = TextUtils.addTextByFamily(scene, creatureName,
            0, 70 / CU.S, '#d7d7d7', 13 / CU.S, 'normal', 450, Fonts.MYRIADPRO_REGULAR);
        this.add(nameLabel);
    }
}
